module.exports = __webpack_public_path__ + "img/kyouzai_junior_high_school_figure.cd470d58.png";